
import Vue, { PropType } from "vue";
import { DynamicItem, MainMenuItem } from "./../interfaces/Toolbar";
import ToolbarItem from "./ToolbarItem.vue";

export default Vue.extend({
  components: { ToolbarItem },
  props: {
    isDeletable: Boolean,
    limit: {
      type: Number,
      required: false,
      default: 52, // max items displayed on 4k screen in FSEND (site-transfer IDs 1->52)
    },
    mainMenu: Boolean,
    menu: {
      type: Array as PropType<DynamicItem[] | MainMenuItem[]>,
      required: true,
    },
  },
  methods: {
    handleDelete(link: DynamicItem) {
      return this.$emit("delete", link);
    },
  },
});
